<template>
    <div v-if='media' v-show='media.type == "downloadable"'>
        <h2>This file cannot be viewed without first being downloading.</h2>
        <a target="_blank" :href='media.full_path'>
            <!-- bytes to MB -->
            <button class='btn btn-primary'>
                Download ({{(media.size / 1000000).toFixed(1)}} MB)
            </button>
        </a>
    </div>
</template>

<script>

    export default {
        props: ['media'],
    }
</script>

<style lang='scss' scoped>
    @import '../../sass/variables.scss';
    p {
        color: white;
    }
    div {
        text-align: center;
        background-color: $dark_gray;
        width: 100%;
        height: 90%;
        border: 1px solid #ddd;
        border-radius: 4px;
        transition: border 0.2s ease-in-out;
        padding: 20px;
    }
</style>
